import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Refreshes its contents from the section HTML the variant picker fetches, the
 * same way the inventory block does, for markup Horizon does not update itself
 * on a variant change. Matched by `data-key`, which must be unique on the page.
 * Used by the product delivery timeline and the restock trigger, which both
 * depend on which delivery is chosen.
 */
class VariantRefresh extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const selector = `variant-refresh[data-key="${CSS.escape(this.dataset.key ?? '')}"]`;
        const next = detail.html.querySelector(selector);
        if (!next) return;

        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-refresh] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('variant-refresh')) {
  customElements.define('variant-refresh', VariantRefresh);
}
